export default __webpack_public_path__ + "static/media/ToyotaType-LightIt.53bffe75.ttf";